<template>
  <v-dialog
    v-model="isDialogOpen"
    persistent
    max-width="640">
    <v-card>
      <v-card-title class="title-form">
        {{isEdit ? 'Editar punto de venta':'Agregar punto de venta'}}
      </v-card-title>
      <v-card-text>
        <div class="container-form">

          <div class="div-row-form">
            <div class="container-input-image" @click="selectFile">
              <img :src="imageUrl" class="img-selected-form" />
              <input type="file"
                ref="fileInput"
                @change="onFileChange"
                accept="image/*"
                style="display: none;"/>
            </div>

            <div class="section-swich-form">
              <div class="container-input-switch">
                <div class="title-switch-component" >
                  <h1> Activar existencias</h1>
                  <h3> Visible en productos </h3>
                </div>
                <v-switch
                  v-model="pos.available_stock"
                  color="black"
                  hide-details
                ></v-switch>
              </div>
            </div>

          </div>

          <v-text-field
            label="Nombre del punto de venta"
            placeholder="Nombre del punto de venta"
            v-model="pos.name"
            color="#222222"
            variant="underlined"
            type="text"
            :rules="rules.required"/>
          <v-text-field
            label="Breve descripción"
            placeholder="Breve descripción"
            v-model="pos.description"
            color="#222222"
            variant="underlined"
            type="text"
            :rules="rules.required"/>

          <v-text-field
            label="Código de seguridad (4 dígitos)"
            placeholder="Código de seguridad"
            v-model="pos.passkey"
            color="#222222"
            variant="underlined"
            :type="showedPin ? 'text' : 'password'"
            :rules="rules.required"
            autocomplete="off"
            maxlength="4"
             @input="pos.passkey = pos.passkey.replace(/\D/g, '').slice(0,4)">
            <template v-slot:append-inner>
              <v-icon color="#222222" icon="mdi-eye-outline" size="small" v-if="!showedPin" v-on:click="showedPin = !showedPin"/>
              <v-icon color="#222222" icon="mdi-eye-off-outline" size="small" v-if="showedPin" v-on:click="showedPin = !showedPin"/>
            </template>
          </v-text-field>

        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          class="btn-cancel-form"
          color="#6E6E6E"
          variant="text"
          rounded="xl"
          @click="isDialogOpen = false">
          Cancelar
        </v-btn>
        <v-btn
          class="btn-action-form"
          rounded="xl"
          color="#FFFFFF"
          :loading="isSavingData"
          :disabled="disableBtn()"
          @click="actionBtn">
          {{'Guardar' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import posApi from '@/api/terminalsApi'
export default {
  name: 'CommerciaVueAddEditTerminals',
  emits: ['refreshList'],
  data () {
    return {
      imageData: null,
      imageUrl: require('../../assets/imgs/svgs/upload-img.svg'),
      validData: true,
      isSavingData: false,
      isDialogOpen: false,
      isEdit: false,
      showedPin: false,
      business: this.$store.getters.business,
      pos: this.initObj(),
      rules: {
        required: [
          v => !!v || 'Campo requerido.'
        ]
      }

    }
  },
  methods: {
    initObj () {
      return {
        _id: null,
        business: null,
        name: null,
        description: null,
        active: null,
        created_at: null,
        updated_at: null,
        passkey: null,
        available_stock: true
      }
    },
    add () {
      this.imageUrl = require('../../assets/imgs/svgs/upload-img.svg')
      this.pos = this.initObj()
      this.pos._id = '-'
      this.pos.updated_at = Date.now()
      this.pos.created_at = Date.now()
      this.pos.active = true
      this.pos.business = this.business._id
      this.isDialogOpen = true
      this.isEdit = false
    },
    edit (pos) {
      this.isDialogOpen = true
      this.isEdit = true
      this.pos = structuredClone(pos)
      this.imageUrl = pos.img || require('../../assets/imgs/svgs/upload-img.svg')
    },
    actionBtn () {
      if (this.isEdit) {
        this.editPos()
      } else {
        this.addPos()
      }
    },
    async addPos () {
      if (await posApi.add(this.pos, this.imageData)) {
        this.isSavingData = false
        this.isDialogOpen = false
        this.$emit('refreshList')
      } else {
        this.isSavingData = true
        // mostar el error
      }
    },

    async editPos () {
      if (await posApi.edit(this.pos, this.imageData)) {
        this.isSavingData = false
        this.isDialogOpen = false
        this.$emit('refreshList')
      } else {
        this.isSavingData = true
        // mostar el error
      }
    },

    disableBtn () {
      return Object.values(this.pos).some(value => value === null || value === '')
    },
    onFileChange (event) {
      const file = event.target.files[0]
      if (file && file.type.startsWith('image/')) {
        this.imageData = file
        this.imageUrl = URL.createObjectURL(file)
      } else {
        alert('Por favor selecciona un archivo de imagen válido.')
      }
    },
    selectFile () {
      this.$refs.fileInput.click()
    }
  }
}
</script>
<style scoped>
  @import '@/assets/styles/forms.css';
</style>
